module.exports = __webpack_public_path__ + "img/hizmet_saglayici_magaza.f7c1f9fa.svg";